import { inject, observer } from "mobx-react";
import React, { FC } from "react";
import { FormattedMessage } from "react-intl";
import { compose } from "recompose";

import AnchorButton from "nvent-web/components/Button/AnchorButton";
import AppStore from "nvent-web/stores/App";

import style from "./CatalogBar.module.scss";

interface CatalogBarPropsInner {
  app: AppStore;
}

const CatalogBarInner: FC<CatalogBarPropsInner> = ({ app }: CatalogBarPropsInner) => {
  let catalogUrl;

  try {
    catalogUrl = require(`nvent-web/assets/pdf/raychem-catalog-${app.locale}.pdf`);
  } catch (err) {
    catalogUrl = require(`nvent-web/assets/pdf/raychem-catalog-en.pdf`);
  }

  const downloadButtonProps =
    app.locale === "sv"
      ? {
          href: "http://raychemgolvvarme.se/kunskapsbank/installationsmanualer",
        }
      : {
          download: `Raychem-Catalog-${app.locale}`,
          href: catalogUrl,
        };

  return (
    <section className={style.signUpBar}>
      <div className={style.signUpBarContent}>
        <h2 className={style.signUpTitle}>
          <FormattedMessage id="certifiedPage.catalog.title" />
        </h2>
        <AnchorButton className={style.signUpButton} {...downloadButtonProps}>
          <FormattedMessage id="certifiedPage.catalog.button" />
        </AnchorButton>
      </div>
    </section>
  );
};

export const CatalogBar = compose<CatalogBarPropsInner, {}>(
  inject("app"),
  observer
)(CatalogBarInner);
